import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme/M365PulseTheme.types";

export const useM365AlertStyles = makeStyles({
    root: {
        minHeight: "26px",
        ...shorthands.padding("0", "6px"),
        backgroundColor: "transparent",
        ...shorthands.border("none"),
        fontSize: themeTokens.fontSizeBase200,
        fontWeight: themeTokens.fontWeightRegular
    }
});
